import { Component, OnInit } from '@angular/core';
import { VideoComponent } from '../video/video.component';
import { MatDialog } from '@angular/material/dialog';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { VideostreamingComponent } from '../videostreaming/videostreaming.component';
@Component({
  selector: 'app-dvr-nvrstatus',
  templateUrl: './dvr-nvrstatus.component.html',
  styleUrls: ['./dvr-nvrstatus.component.scss']
})
export class DvrNvrstatusComponent implements OnInit {
  totaldvrstatus: any;
  searchkey: string = '';
  public searchTerm: string = '';

  constructor(private dailog: MatDialog,public campuscctvserviceservice: CampuscctvserviceService,private spinner: NgxSpinnerService){}
  ngOnInit(): void {
    this.spinner.show();
    this.campuscctvserviceservice.gettotaldvr().subscribe((res)=>{
      this.totaldvrstatus=res;
      console.log(this.totaldvrstatus); 
      this.spinner.hide();
    });
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });
  }

  // (click)="openvideo(frame)"
  // openvideo(frame: any) {
  //   this.dailog.open(VideoComponent, {
  //     data: frame,
  //     width: '650px', height: '490px',
  //   })
  // }

  openvideostreaming(frame: any) {
    this.dailog.open(VideostreamingComponent, {
      data: frame,
      width: '90%', height: '80%',
    })
  }


  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
}
}